// src/pages/hr/HRRecruitment.jsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HR_NAV } from "../../utils/navigation";
import Layout from "../../components/common/Layout";
import { RecruitmentProvider } from "../../context/RecruitmentContext";

import RecruitmentDashboard from "./recruitment/RecruitmentDashboard";
import JobOpenings from "./recruitment/JobOpenings";
import CandidateList from "./recruitment/CandidateList";
import PipelineKanban from "./recruitment/PipelineKanban";
import InterviewScheduler from "./recruitment/InterviewScheduler";
import HiringRequests from "./recruitment/HiringRequests";
import HRAssignedCandidates from "./recruitment/HRAssignedCandidates";
import RecruitmentActivity from "./recruitment/RecruitmentActivity";

import {
  LayoutDashboard,
  Briefcase,
  User,
  GitPullRequest,
  Calendar,
  Award,
  Inbox,
  Activity,
} from "lucide-react";

const PANEL_LABEL = "HR Panel";

export default function HRRecruitment() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const initialTab = searchParams.get("tab") || "dashboard";

  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    const tabFromUrl = new URLSearchParams(location.search).get("tab");
    if (tabFromUrl) setActiveTab(tabFromUrl);
  }, [location.search]);

  const tabs = [
    { id: "dashboard", label: "Overview", Icon: LayoutDashboard },
    { id: "jobs", label: "Job Openings", Icon: Briefcase },
    { id: "candidates", label: "Candidates", Icon: User },
    { id: "pipeline", label: "Pipeline Kanban", Icon: GitPullRequest },
    { id: "interviews", label: "Interviews", Icon: Calendar },
    { id: "finalReview", label: "HR Final Review", Icon: Award },
    { id: "requests", label: "Hiring Requests", Icon: Inbox },
    { id: "activity", label: "Audit Logs", Icon: Activity },
  ];

  return (
    <Layout navItems={HR_NAV} panelLabel={PANEL_LABEL}>
      <RecruitmentProvider>
        <style>{`
          .ats-tabs-bar { display: flex; gap: 0.5rem; border-bottom: 2px solid var(--border, #e5e7eb); margin-bottom: 1.5rem; overflow-x: auto; padding-bottom: 2px; }
          .ats-tab-btn { display: inline-flex; align-items: center; gap: 0.45rem; padding: 0.65rem 1.1rem; background: none; border: none; font-weight: 600; font-size: 0.86rem; cursor: pointer; color: var(--text-muted, #6b7280); border-bottom: 3px solid transparent; margin-bottom: -2px; white-space: nowrap; transition: all 0.2s; }
          .ats-tab-btn:hover { color: #1b4b31; }
          .ats-tab-btn.active { color: #1b4b31; border-bottom-color: #1b4b31; font-weight: 700; }
          .ats-tab-btn svg { color: #1b4b31; }
        `}</style>

        {/* Module Title Header */}
        <div className="page-header" style={{ marginBottom: "1rem" }}>
          <div>
            <h1 className="page-title">Enterprise Recruitment ATS</h1>
          </div>
        </div>

        {/* ATS Module Navigation Bar */}
        <div className="ats-tabs-bar">
          {tabs.map(({ id, label, Icon }) => (
            <button
              key={id}
              className={`ats-tab-btn ${activeTab === id ? "active" : ""}`}
              onClick={() => setActiveTab(id)}
            >
              <Icon size={16} style={{ strokeWidth: 1.75 }} />
              <span>{label}</span>
            </button>
          ))}
        </div>

        {/* Tab View Component Rendering */}
        <div>
          {activeTab === "dashboard" && <RecruitmentDashboard />}
          {activeTab === "jobs" && <JobOpenings />}
          {activeTab === "candidates" && <CandidateList />}
          {activeTab === "pipeline" && <PipelineKanban />}
          {activeTab === "interviews" && <InterviewScheduler />}
          {activeTab === "finalReview" && <HRAssignedCandidates />}
          {activeTab === "requests" && <HiringRequests />}
          {activeTab === "activity" && <RecruitmentActivity />}
        </div>
      </RecruitmentProvider>
    </Layout>
  );
}
